// import React, { useRef } from 'react';
// import '../Styles/Chat.css';
// import { motion, useInView } from 'framer-motion';

// import {
//     FiHelpCircle,
// } from 'react-icons/fi';

// function useFaqInViews(length) {
//     const refs = React.useMemo(() => Array.from({ length }, () => React.createRef()), [length]);
//     // Call useInView for each ref, but outside of any loop/callback
//     const inViews = [];
//     for (let i = 0; i < length; i++) {
//         // eslint-disable-next-line react-hooks/rules-of-hooks
//         inViews[i] = useInView(refs[i], { amount: 0.2 });
//     }
//     return [refs, inViews];
// }
// const Faq = ({
//     setInputText,
//     setActiveNavItem,
//     setShowFAQ,
//     handleSendMessage,
//     setFaqQuestionSelected
// }) => {
//     const itemVariants = {
//         hidden: { opacity: 0, scale: 0.96, y: 20 },
//         visible: { opacity: 1, scale: 1, y: 0, transition: { duration: 0.13, ease: 'easeInOut' } },
//         exit: { opacity: 0, scale: 0.96, y: -20, transition: { duration: 0.13, ease: 'easeInOut' } }
//     };
//     const faqData = [
        // {
        //     question: "List accounts with annual revenue greater than 5,000,000 that were updated before one year",
        //     answer: "The Customer Data Quality Agent analyzes and summarizes customer data issues, identifying inconsistencies, missing values, and duplicate records to improve data accuracy."
        // },
        // {
        //     question: "Show me accounts that have no ERP or unknown CRM system",
        //     answer: "It monitors inventory levels across different stores, automates stock checks, and optimizes stock distribution based on real-time data and demand."
        // },
        // {
        //     question: "Are there any accounts with low revenue or small number of employees?",
        //     answer: "This agent predicts future product demand using historical sales data, stock levels, and market trends to help businesses maintain optimal inventory."
        // },
        // {
        //     question: "Group accounts by email domain",
        //     answer: "It analyzes sales data across different regions, identifies top-selling and underperforming products, and provides insights for sales growth."
        // },
        // {
        //     question: "How many companies are there in each sector?",
        //     answer: "The Pricing Agent tracks product pricing variations across multiple locations and generates alerts for competitive pricing strategies."
        // },
        // {
        //     question: "Which accounts have missing ownership or blank ownership status?",
        //     answer: "It provides marketing trend analysis, suggests customer engagement strategies, and recommends sales optimization techniques for better business growth."
        // },
        // {
        //     question: "Show me companies with revenue more than 50000",
        //     answer: "It analyzes vendor performance, logistics planning, and supply trends to reduce costs and improve delivery times."
        // },
        // {
        //     question: "Find companies with less than 100 employees",
        //     answer: "This agent creates detailed visual reports by compiling insights from multiple agents, making complex data easier to interpret."
        // },
        // {
        //     question: "Are there any high revenue accounts that aren't being targeted but have ERP and CRM systems in place?",
        //     answer: "It processes raw data, removes errors, and structures it properly for accurate analysis, covering areas like Material Master, Customer Master, and Vendor Master."
        // },
        // {
        //     question: "Break down the revenue by month for the third quarter of 2023",
        //     answer: "The Orchestrator Agent coordinates communication between all sub-agents, retrieves necessary details, and provides a comprehensive trend analysis."
        // },
        // {
        //     question: "Generate comprehensive Monday morning CRM report",
        //     answer: "It tracks material balances in real time and alerts businesses when stock levels are low, ensuring timely restocking."
        // },
        // {
        //     question: "Analyze opportunities requiring immediate attention",
        //     answer: "Yes, it analyzes past seasonal sales trends to predict demand spikes and helps businesses plan accordingly."
        // },
        // {
        //     question: "Find stagnant opportunities over 30 days",
        //     answer: "It compares sales data across regions, products, and time periods to identify growth opportunities and weak spots."
        // },
        // {
        //     question: "Find urgent opportunities and send email to sales team",
        //     answer: "It analyzes yearly, monthly, and seasonal sales patterns to recommend competitive pricing strategies."
        // },
        // {
        //     question: "Create executive summary of current opportunities",
        //     answer: "It suggests content strategies, customer engagement ideas, and sales optimization plans based on current market trends."
        // },
//         {
//             question: "How does the Supply Chain Optimization Agent improve vendor management?",
//             answer: "It assesses vendor performance, delivery speed, and pricing to recommend the best vendors for cost-effectiveness and efficiency."
//         },
//         {
//             question: "Can the Visualization and Reporting Agent generate custom reports?",
//             answer: "Yes, it can generate reports tailored to specific business needs by analyzing data from multiple agents."
//         },
//         {
//             question: "Why is the Data Cleaning and Preprocessing Agent crucial for analytics?",
//             answer: "It ensures that raw data is accurate and structured, making it reliable for decision-making and analysis."
//         },
//         {
//             question: "How do multiple AI agents work together?",
//             answer: "The Orchestrator Agent facilitates communication between different agents, ensuring seamless collaboration for data-driven decision-making."
//         },
//         {
//             question: "How does the Customer Data Quality Agent help reduce duplicate records?",
//             answer: "It identifies and merges duplicate customer data entries to improve database accuracy and prevent redundancy."
//         },
//         {
//             question: "What industries can benefit from these AI agents?",
//             answer: "Retail, manufacturing, logistics, finance, and e-commerce businesses can leverage these AI agents for efficiency and growth."
//         },
//         {
//             question: "How does the system handle large-scale data processing?",
//             answer: "It uses advanced machine learning models to process large datasets efficiently while maintaining accuracy."
//         },
//         {
//             question: "Can businesses integrate these AI agents into existing systems?",
//             answer: "Yes, these AI agents can be integrated via APIs and cloud-based platforms to enhance existing business operations."
//         },
//         {
//             question: "What are the key benefits of using AI-driven agents?",
//             answer: "They improve efficiency, automate repetitive tasks, enhance data accuracy, and provide actionable insights for better decision-making."
//         }
//     ];

//     const [refs, inViews] = useFaqInViews(faqData.length);


//     const handleQuestionClick = (question) => {
//         // Set the question as input text
//         setInputText(question);

//         // Set active nav item to Chat
//         setActiveNavItem('Chat');
//         setShowFAQ(false);
//         setFaqQuestionSelected(true);
//         // Send the question to the API
//         setTimeout(() => {
//             handleSendMessage();
//         }, 100);
//     };


//     return (
//         <div className="faq-container">
//             <div className="faq-header">
//                 <h2>Frequently Asked Questions</h2><br />
//                 <p>Click on any question to get an AI-powered response</p>
//             </div>
//             <div className="faq-list">
//                 {faqData.map((faq, index) => (
//                     <motion.div
//                         key={index}
//                         ref={refs[index]}
//                         className="faq-item"
//                         initial="hidden"
//                         animate={inViews[index] ? "visible" : "exit"}
//                         variants={itemVariants}
//                     >
//                         <div
//                             className="faq-question"
//                             onClick={() => handleQuestionClick(faq.question)}
//                             style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
//                         >
//                             <FiHelpCircle size={16} className="faq-icon" style={{ marginRight: '10px' }} />
//                             <h3 style={{ margin: 0, fontSize: '16px' }}>{faq.question}</h3>
//                         </div>
//                     </motion.div>
//                 ))}
//             </div>
//         </div>
//     );
// };

// export default Faq;

import React from 'react';
import '../Styles/Chat.css';
import { motion } from 'framer-motion';
import { FiHelpCircle } from 'react-icons/fi';

const Faq = ({
    setInputText,
    setActiveNavItem,
    setShowFAQ,
    handleSendMessage,
    setFaqQuestionSelected
}) => {
    const itemVariants = {
        hidden: { opacity: 0, scale: 0.96, y: 20 },
        visible: { opacity: 1, scale: 1, y: 0, transition: { duration: 0.13, ease: 'easeInOut' } },
        exit: { opacity: 0, scale: 0.96, y: -20, transition: { duration: 0.13, ease: 'easeInOut' } }
    };

    const faqData = [
        {
            question: "List accounts with annual revenue greater than 5,000,000 that were updated before one year",
            answer: "The Customer Data Quality Agent analyzes and summarizes customer data issues, identifying inconsistencies, missing values, and duplicate records to improve data accuracy."
        },
        {
            question: "Show me accounts that have no ERP or unknown CRM system",
            answer: "It monitors inventory levels across different stores, automates stock checks, and optimizes stock distribution based on real-time data and demand."
        },
        {
            question: "Are there any accounts with low revenue or small number of employees?",
            answer: "This agent predicts future product demand using historical sales data, stock levels, and market trends to help businesses maintain optimal inventory."
        },
        {
            question: "Group accounts by email domain",
            answer: "It analyzes sales data across different regions, identifies top-selling and underperforming products, and provides insights for sales growth."
        },
        {
            question: "How many companies are there in each sector?",
            answer: "The Pricing Agent tracks product pricing variations across multiple locations and generates alerts for competitive pricing strategies."
        },
        {
            question: "Which accounts have missing ownership or blank ownership status?",
            answer: "It provides marketing trend analysis, suggests customer engagement strategies, and recommends sales optimization techniques for better business growth."
        },
        {
            question: "Show me companies with revenue more than 50000",
            answer: "It analyzes vendor performance, logistics planning, and supply trends to reduce costs and improve delivery times."
        },
        {
            question: "Find companies with less than 100 employees",
            answer: "This agent creates detailed visual reports by compiling insights from multiple agents, making complex data easier to interpret."
        },
        {
            question: "Are there any high revenue accounts that aren't being targeted but have ERP and CRM systems in place?",
            answer: "It processes raw data, removes errors, and structures it properly for accurate analysis, covering areas like Material Master, Customer Master, and Vendor Master."
        },
        {
            question: "Break down the revenue by month for the third quarter of 2023",
            answer: "The Orchestrator Agent coordinates communication between all sub-agents, retrieves necessary details, and provides a comprehensive trend analysis."
        },
        {
            question: "Generate comprehensive Monday morning CRM report",
            answer: "It tracks material balances in real time and alerts businesses when stock levels are low, ensuring timely restocking."
        },
        {
            question: "Analyze opportunities requiring immediate attention",
            answer: "Yes, it analyzes past seasonal sales trends to predict demand spikes and helps businesses plan accordingly."
        },
        {
            question: "Find stagnant opportunities over 30 days",
            answer: "It compares sales data across regions, products, and time periods to identify growth opportunities and weak spots."
        },
        {
            question: "Find urgent opportunities and send email to sales team",
            answer: "It analyzes yearly, monthly, and seasonal sales patterns to recommend competitive pricing strategies."
        },
        {
            question: "Create executive summary of current opportunities",
            answer: "It suggests content strategies, customer engagement ideas, and sales optimization plans based on current market trends."
        }
    ];

    const handleQuestionClick = (question) => {
        setInputText(question);
        setActiveNavItem('Chat');
        setShowFAQ(false);
        setFaqQuestionSelected(true);
        setTimeout(() => {
            handleSendMessage();
        }, 100);
    };

    return (
        <div className="faq-container">
            <div className="faq-header">
                <h2>Frequently Asked Questions</h2><br />
                <p>Click on any question to get an AI-powered response</p>
            </div>
            <div className="faq-list">
                {faqData.map((faq, index) => (
                    <motion.div
                        key={index}
                        className="faq-item"
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ amount: 0.2 }}
                        variants={itemVariants}
                    >
                        <div
                            className="faq-question"
                            onClick={() => handleQuestionClick(faq.question)}
                            style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
                        >
                            <FiHelpCircle size={16} className="faq-icon" style={{ marginRight: '10px' }} />
                            <h3 style={{ margin: 0, fontSize: '16px' }}>{faq.question}</h3>
                        </div>
                    </motion.div>
                ))}
            </div>
        </div>
    );
};

export default Faq;